import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Form, Formik } from "formik";
import Footer from "../../../Components/Footer/footer";
import CustomSelect from "../../../CustomComponent/custom_select";
import { useSelector } from "react-redux";
import { ReimbursementInfo } from "../../../SchemaInfo/info";
import LoadingPage from "../../../Components/layouts/loading";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { getId } from "../../../Components/Functions/word.fun";
import { ReimbursementSchema } from "../../../Schemas/employee/reimbursement";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { BsReceiptCutoff } from "react-icons/bs";
import { FcCalculator } from "react-icons/fc";

const AddReimbursement = () => {
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [showInputBox, setShowInputBox] = useState(false);
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    performRequest("GET", "/siteInspection/getAllProjects")
      .then((res) => setProjects(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);
  const handelSubmit = (values) => {
    values = {
      ...values,
      amount: +values.amount,
      generatedBy: store.Name,
    };
    let val = +values?.selectProject;

    if (typeof val !== "number" || isNaN(val)) {
      values = {
        ...values,
        customClientName: values?.selectProject,
        selectProject: 1,
      };
    }
    let formData = new FormData();
    for (let key in values) {
      formData.append(key, values[key]);
    }
    const headers = { "Content-Type": "multipart/form-data" };
    setLoading(true);
    performRequest(
      "POST",
      "/reimbursement/createReimbursement/",
      formData,
      headers
    )
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Reimbursement generated successfully!");
          navigate(`/reimbursement-management/`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcCalculator className="fs-2  me-1" /> Reimbursement
                  Management
                </h2>
                <h4 className="text-muted">
                  {/* <StepRoutes /> */} Request reimbursements.
                </h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end">
                  <a href={"/reimbursement-management"}>
                    <button className="btn btn-primary">
                      <BsReceiptCutoff className="me-2 fs-2" /> View All
                      Reimbursement
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-3">
                <h3>Reimbursement Policy</h3>
                <p>
                  For claims above ₹2,000: The reimbursement amount will be
                  processed within 2–3 working days from the date of approval.
                </p>
                <p>
                  For claims below ₹2,000: The reimbursement amount will be
                  processed within 6–8 working days from the date of approval.
                </p>
                <p>
                  Claims should be submitted through CRM only i.e Alpha.Kryzen
                </p>
                <p>
                  Claims without adequate documentation or prior intimation may
                  be subject to rejection or adjustment as per company policy.
                </p>
                <button
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#modal-report-2"
                >
                  Read More
                </button>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <Formik
                  initialValues={ReimbursementInfo}
                  validationSchema={ReimbursementSchema}
                  onSubmit={handelSubmit}
                >
                  {(props) => (
                    <Form>
                      <div className="card-body">
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Select project
                          </label>
                          <div className="w-100 col">
                            {!showInputBox && (
                              <CustomSelect
                                onChange={(e) => {
                                  if (e.target.value === "add manually") {
                                    setShowInputBox(true);
                                    props.setFieldValue("selectProject", "");
                                  } else {
                                    props.setFieldValue(
                                      "selectProject",
                                      e.target.value
                                    );
                                  }
                                }}
                                type="text"
                                name="selectProject"
                              >
                                <option value="">Select</option>
                                <option
                                  className="bg-green-lt"
                                  value="add manually"
                                >
                                  Add Manually
                                </option>
                                {projects &&
                                  projects?.map((pro) => {
                                    return (
                                      <option
                                        key={pro.cpNumber}
                                        value={getId(pro.cpNumber)}
                                      >
                                        {pro.clientName == "ABC"
                                          ? "Kryzen Office"
                                          : pro.clientName}
                                      </option>
                                    );
                                  })}
                              </CustomSelect>
                            )}
                            {showInputBox && (
                              <CustomInput name="selectProject" type="text" />
                            )}
                            {props.touched.selectProject &&
                              props.errors.selectProject && (
                                <p className="text-danger">
                                  {props.errors.selectProject}
                                </p>
                              )}
                            {props.touched.clproject &&
                              props.errors.clproject && (
                                <p className="text-danger">
                                  {props.errors.clproject}
                                </p>
                              )}
                          </div>
                          {/* <div className="w-100 col">
                            <CustomSelect type="text" name="selectProject">
                              <option value="">Select</option>
                              {projects &&
                                projects?.map((pro) => {
                                  return (
                                    <option
                                      key={pro.cpNumber}
                                      value={getId(pro.cpNumber)}
                                    >
                                      {pro.clientName == "ABC"
                                        ? "Kryzen Office"
                                        : pro.clientName}
                                    </option>
                                  );
                                })}
                            </CustomSelect>
                            {props.touched.selectProject &&
                              props.errors.selectProject && (
                                <p className="text-danger">
                                  {props.errors.selectProject}
                                </p>
                              )}
                          </div> */}
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Amount
                          </label>
                          <div className="w-100 col">
                            <CustomInput name="amount" />
                            {props.touched.amount && props.errors.amount && (
                              <p className="text-danger">
                                {props.errors.amount}
                              </p>
                            )}
                            <p className="text-muted">
                              Amount mentioned here should be reflected in KBPL
                              bank account.
                            </p>
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Recipt bill
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="addRecipt_bill"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "addRecipt_bill",
                                  e.target.files[0]
                                )
                              }
                            />

                            {props.touched.addRecipt_bill &&
                              props.errors.addRecipt_bill && (
                                <p className="text-danger">
                                  {props.errors.addRecipt_bill}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Mode of payment
                          </label>
                          <div className="w-100 col">
                            <CustomSelect type="text" name="modeOfPayment">
                              <option value="">Select</option>
                              <option value="cash">Cash</option>
                              <option value="nft">NFT</option>
                              <option value="upi">UPI</option>
                              <option value="cheque">Cheque</option>
                            </CustomSelect>
                            {props.touched.modeOfPayment &&
                              props.errors.modeOfPayment && (
                                <p className="text-danger">
                                  {props.errors.modeOfPayment}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Reimbursements description
                          </label>

                          <div className="w-100 col">
                            <CustomTextArea
                              name="reimbursementsDescription"
                              rows={5}
                            />
                            {props.touched.reimbursementsDescription &&
                              props.errors.reimbursementsDescription && (
                                <p className="text-danger">
                                  {props.errors.reimbursementsDescription}
                                </p>
                              )}
                          </div>
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton buttonText="Create Reimbursement" />
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>

        {/* Modal */}
        <div
          className="modal fade"
          id="modal-report-2"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-md modal-md-width" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title"> Reimbursement Policy</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div class="reimbursement-policy">
                  <div class="policy-title">
                    <h2>Reimbursement Policy</h2>
                  </div>

                  <div class="policy-points">
                    <ul>
                      <li>
                        For claims above ₹2,000: The reimbursement amount will
                        be processed within 2–3 working days from the date of
                        approval.
                      </li>

                      <li>
                        For claims below ₹2,000: The reimbursement amount will
                        be processed within 7–8 working days from the date of
                        approval.
                      </li>

                      <li>
                        Reimbursement for any pay done for office work will be
                        considered, Only expenses like the travel, client
                        meetings, office purchases, etc. can be reimbursed.
                      </li>

                      <li>
                        All employees are eligible to apply for reimbursement.
                      </li>

                      <li>
                        However, prior intimation is mandatory. Employees must
                        inform why the expense is required and who will be
                        making the payment before spending.
                      </li>

                      <li>
                        Claims without prior approval will not be processed.
                      </li>

                      <li>
                        Employees must submit claims on the same day i.e on the
                        date of expenses made.
                      </li>

                      <li>Late submissions may require extra approval.</li>

                      <li>
                        Claims should be submitted through CRM only i.e
                        Alpha.Kryzen
                      </li>

                      <li>All documents must be clear and readable.</li>
                    </ul>
                  </div>

                  <div class="policy-section">
                    <p>
                      <strong>Non-Reimbursable Items-</strong>
                    </p>
                    <ul>
                      <li>Personal expenses</li>
                      <li>Snacks/food unless work-related</li>
                      <li>Unapproved purchases</li>
                      <li>Fuel claims without log or travel reason</li>
                    </ul>
                  </div>

                  <div class="policy-points">
                    <ul>
                      <li>
                        Verifications for the reimbursement can be done by
                        Accounts or HR teams.
                      </li>

                      <li>
                        Any mismatch or manipulated document will result in
                        rejection and possible disciplinary action.
                      </li>

                      <li>
                        Payments will be processed via bank transfer / salary
                        account.
                      </li>

                      <li>
                        Employees will be informed once reimbursement is
                        completed.
                      </li>

                      <li>
                        Employees must fill all mandatory fields (date, purpose,
                        amount, vendor).
                      </li>

                      <li>
                        Duplicate bills or unclear photocopies will not be
                        accepted.
                      </li>

                      <li>
                        If cash is used, a proper cash receipt must be attached
                        with vendor details.
                      </li>

                      <li>
                        For employees traveling or purchasing in foreign
                        currency, reimbursement will be processed based on the
                        exchange rate of that day.
                      </li>

                      <li>
                        If an employee seeks reimbursement for fuel expenses,
                        they must submit photographic proof clearly showing the
                        fuel level before travel and the fuel level upon
                        reaching the destination.
                      </li>

                      <li>
                        Reimbursement shall be calculated only for the actual
                        fuel consumed during official travel based on this
                        submitted proof.
                      </li>
                    </ul>
                  </div>

                  <div class="policy-section">
                    <p>
                      In cases where relevant or valid proof (as mentioned
                      above) is not submitted, fuel reimbursement will be
                      processed on a standard per-kilometer basis as follows:
                    </p>

                    <ul>
                      <li>Petrol Car: ₹7 per km</li>
                      <li>Bike: ₹3 per km</li>
                    </ul>

                    <p>
                      These rates shall be considered final and non-negotiable.
                    </p>
                  </div>

                  <div class="policy-points">
                    <ul>
                      <li>
                        Claims without adequate documentation or prior
                        intimation may be subject to rejection or adjustment as
                        per company policy.
                      </li>

                      <li>
                        For any expense paid through bank transfer, UPI, or
                        online payment, employees must submit valid documentary
                        proof clearly showing that the payment was made to the
                        specific business/vendor and/or individual concerned.
                      </li>

                      <li>
                        Merely providing bank account numbers or transaction
                        references without identifiable payee details will not
                        be accepted as valid proof.
                      </li>

                      <li>
                        Employees are required to capture and retain a
                        screenshot or acknowledgment of the successful payment
                        at the time of transaction, clearly reflecting the payee
                        name, amount, and date, and submit the same along with
                        the reimbursement claim.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" data-bs-dismiss="modal">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};
export default AddReimbursement;
